var React = require('react');

function SpeechBubbleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m124.232 116.879s14.798-10.741 11.442-25.1349c0 0 12.891-3.8402 13.604-17.0294.906-16.6937-3.633-47.5835-8.331-58.6798-4.048-9.57594-9.929-10.90868-17.13-11.84653-7.202-.93785-51.8572-7.95324-98.4481-.00094-34.99052 5.97227-25.174036 68.78977-20.27348 79.37277 1.97087 4.2548 8.79968 10.2669 20.27338 12.7152 25.7705 5.4986 49.2399 4.8076 88.3272.2863 0 0 13.2 5.7853 7.564 19.5473l2.951.779z"}));
}

SpeechBubbleInline.defaultProps = {"height":"117","viewBox":"0 0 150 117","width":"150"};

module.exports = SpeechBubbleInline;

SpeechBubbleInline.default = SpeechBubbleInline;
